export const MAX_TOPIC_NAME_LENGTH = 20;

export const allowedRegex = /^[\p{L}\p{N}!№;%:?*()'=+\-\s/]*$/u;

export const normalize = (s: string) => s.trim().toLowerCase();

export const DEBOUNCE_TIME = 300;
